import React from 'react';
import { Button } from 'reactstrap';

import { formulasButton } from '../../configs';

interface Props {
  isDisabled?: boolean;
  onClick: (value: string) => void;
}

export const FormulasButtonsList = ({ isDisabled, onClick }: Props) => (
  <ul className="math-row">
    {formulasButton.map(item => (
      <li key={item}>
        <Button className="formula-icon-btn" onClick={() => onClick(item)} disabled={isDisabled}>
          {item}
        </Button>
      </li>
    ))}
  </ul>
);
